import * as React from 'react'
import { Limit } from '../../components'
import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import { LabelLarge } from 'baseui/typography';
import { FormControl } from 'baseui/form-control';
import { ISensorAnalog } from './types'
import { SensorRangeConfig } from '../../components/SensorRangeConfig'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';

export const ConfigurationPanel = (props: ISensorAnalog) => {


    const rangeMin = props.rangeMin ?? 0;
    const rangeMax = props.rangeMax ?? 100;
    const [warnDelay, setWarnDelay, setWarnDelayResult] = useSetObjectValue(props.id, props.resourceGroupId, "warningDelay", props.warningDelay, 3000);
    const onWarnDelayChanged = (e: any) => setWarnDelay(parseFloat(e.target.value));

    // alarm limit low
    const [enableAlarmLimitLow, setEnableAlarmLimitLow] = useSetObjectValue(props.id, props.resourceGroupId, "enableAlarmLimitLow", props.enableAlarmLimitLow);
    const [alarmLimitLow, setAlarmLimitLow] = useSetObjectValue(props.id, props.resourceGroupId, "alarmLimitLow", props.alarmLimitLow, 3000);
    const onAlarmLimitLowChanged = (newvalue: number) => {
        const alarmLimitLowLimitedValue = Math.max(Math.min(newvalue, rangeMax, alarmLimitHigh), rangeMin);
        //const alarmLimitLowLimitedValue = newvalue;
        setAlarmLimitLow(alarmLimitLowLimitedValue);
    }

    // alarm limit high
    const [enableAlarmLimitHigh, setEnableAlarmLimitHigh] = useSetObjectValue(props.id, props.resourceGroupId, "enableAlarmLimitHigh", props.enableAlarmLimitHigh);
    const [alarmLimitHigh, setAlarmLimitHigh] = useSetObjectValue(props.id, props.resourceGroupId, "alarmLimitHigh", props.alarmLimitHigh, 3000);
    const onAlarmLimitHighChanged = (newvalue: number) => {
        const alarmLimitHighLimitedValue = Math.max(Math.min(newvalue, rangeMax), rangeMin, alarmLimitLow);
        //const alarmLimitHighLimitedValue = newvalue;
        setAlarmLimitHigh(alarmLimitHighLimitedValue);
    }

    // warning limit low
    const [enableWarningLimitLow, setEnableWarningLimitLow] = useSetObjectValue(props.id, props.resourceGroupId, "enableWarningLimitLow", props.enableWarningLimitLow);
    const [warningLimitLow, setWarningLimitLow] = useSetObjectValue(props.id, props.resourceGroupId, "warningLimitLow", props.warningLimitLow, 3000);
    const onWarningLimitLowChanged = (newvalue: number) => {
        const warningLimitLowLimitedValue = Math.max(Math.min(newvalue, rangeMax, warningLimitHigh), rangeMin);
        //const warningLimitLowLimitedValue = newvalue;
        setWarningLimitLow(warningLimitLowLimitedValue);
    }

    // warning limit high

    const [enableWarningLimitHigh, setEnableWarningLimitHigh] = useSetObjectValue(props.id, props.resourceGroupId, "enableWarningLimitHigh", props.enableWarningLimitHigh);
    const [warningLimitHigh, setWarningLimitHigh] = useSetObjectValue(props.id, props.resourceGroupId, "warningLimitHigh", props.warningLimitHigh, 3000);
    const onWarningLimitHighChanged = (newvalue: number) => {
        const warningLimitHighLimitedValue = Math.max(Math.min(newvalue, rangeMax), rangeMin, warningLimitLow);
        //const warningLimitHighLimitedValue = newvalue;
        setWarningLimitHigh(warningLimitHighLimitedValue);
    }


    const hasLimitLow = props.alarmLimitLow !== undefined && props.alarmLimitLow !== null;
    const hasLimitHigh = props.alarmLimitHigh !== undefined && props.alarmLimitHigh !== null;
    const hasAlarmDelay = props.alarmDelay !== undefined && props.alarmDelay !== null;
    const hasRangeMin = props.rangeMin !== undefined && props.rangeMin !== null;
    const hasRangeMax = props.rangeMax !== undefined && props.rangeMax !== null;
    const hasDeadBand = props.deadBand !== undefined && props.deadBand !== null;

    const wlLow = props.warningLimitLow;
    const wlow = wlLow ?
        (
            <Limit
                enable={enableWarningLimitLow}
                min={rangeMin}
                max={rangeMax}
                dimension={props.dimension}
                value={warningLimitLow}
                onEnableChanged={setEnableWarningLimitLow}
                onValueChanged={onWarningLimitLowChanged}
                name={<FormattedMessage id="Devices.Low" defaultMessage="Low" />}></Limit>
        ) : (<></>);

    const wlHigh = props.warningLimitHigh;
    const whigh = wlHigh ?
        (
            <Limit
                enable={enableWarningLimitHigh}
                min={rangeMin}
                max={rangeMax}
                dimension={props.dimension}
                value={warningLimitHigh}
                onEnableChanged={setEnableWarningLimitHigh}
                onValueChanged={onWarningLimitHighChanged}
                name={<FormattedMessage id="Devices.High" defaultMessage="High" />}></Limit>
        ) : (<></>);

    return (
        <Block gridRowGap='20px' minWidth={'200px'} minHeight={'200px'} justifyContent='center' display='flex' flexDirection='column' flexWrap>
            {(hasLimitLow || hasLimitHigh) &&
                <>
                    <LabelLarge>{<FormattedMessage id="Devices.AlarmLimits" defaultMessage="Alarm Limits" />}</LabelLarge>
                    {hasLimitLow && <Limit
                        enable={enableAlarmLimitLow}
                        min={rangeMin}
                        max={rangeMax}
                        dimension={props.dimension}
                        value={alarmLimitLow}
                        onEnableChanged={setEnableAlarmLimitLow}
                        onValueChanged={onAlarmLimitLowChanged}
                        name={<FormattedMessage id="Devices.Low" defaultMessage="Low" />} ></Limit>
                    }
                    {hasLimitHigh && <Limit
                        enable={enableAlarmLimitHigh}
                        min={rangeMin}
                        max={rangeMax}
                        dimension={props.dimension}
                        value={alarmLimitHigh}
                        onEnableChanged={setEnableAlarmLimitHigh}
                        onValueChanged={onAlarmLimitHighChanged}
                        name={<FormattedMessage id="Devices.High" defaultMessage="High" />}></Limit>
                    }
                    {hasAlarmDelay && <AlarmDelayForm {...props}></AlarmDelayForm>}
                    {hasDeadBand && <DeadBandForm {...props}></DeadBandForm>}
                </>
            }
            {(wlLow || wlHigh) &&
                <><LabelLarge>{<FormattedMessage id="Devices.WarningLimits" defaultMessage="Warning Limits" />}</LabelLarge>
                    {wlow}
                    {whigh}

                </>}
            {(hasRangeMin || hasRangeMax) && <SensorRangeForm {...props}></SensorRangeForm>}
        </Block>
    )
}

const AlarmDelayForm = (props: ISensorAnalog) => {
    const [alarmDelay, setAlarmDelay, setAlarmDelayResult] = useSetObjectValue(props.id, props.resourceGroupId, "alarmDelay", props.alarmDelay, 3000);
    const onAlarmDelayChanged = (e: any) => setAlarmDelay(parseFloat(e.target.value));

    return (<>
        <FormControl
            label={<FormattedMessage id="Devices.Delay" defaultMessage="Delay" />}
            caption={<FormattedMessage id="Devices.TextDelay" defaultMessage="Enter the delay time" />}        >
            <Input
                value={alarmDelay}
                onChange={onAlarmDelayChanged}
                error={setAlarmDelayResult.isError}
                endEnhancer='sec'
                type='number'
            />
        </FormControl>
    </>)
}

const DeadBandForm = (props: ISensorAnalog) => {
    const [deadBand, setdeadBand, setdeadBandresult, sendNow] = useSetObjectValue(props.id, props.resourceGroupId, "deadBand", props.deadBand, 3000);

    const onValueChanged = (e: any) => setdeadBand(e.target.value);
    const onBlur = (e: any) => sendNow(e.target.value);

    return (<FormControl
        label={<FormattedMessage id="SensorAnalog.Deadband" defaultMessage="Deadband" />}
        caption={<FormattedMessage id="SensorAnalog.TextDeadband" defaultMessage="Enter the deadband" />}

    >
         <Input 
            value={deadBand}
            type='number'
            onBlur={onBlur}
            onChange={onValueChanged}
            endEnhancer={props.dimension}
            error={setdeadBandresult.isError}
        />
    </FormControl>
    )
}


const SensorRangeForm = (props: ISensorAnalog) => {
    const [rangeMin, setRangeMin, setRangeMinResult] = useSetObjectValue(props.id, props.resourceGroupId, "rangeMin", props.rangeMin ?? 0, 3000);
    const [rangeMax, setRangeMax, setRangeMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "rangeMax", props.rangeMax ?? 100, 3000);
    const onRangeMaxChanged = (e: any) => setRangeMax(e.target.value);
    const onRangeMinChanged = (e: any) => setRangeMin(e.target.value);

    return (

        <SensorRangeConfig rangeMin={rangeMin} rangeMax={rangeMax} dimension={props.dimension}
            onRangeMinChanged={onRangeMinChanged} onRangeMaxChanged={onRangeMaxChanged}
            errorMin={setRangeMinResult.error}
            errorMax={setRangeMaxResult.error}
        ></SensorRangeConfig>

    )
}

